/* eslint-disable no-shadow */
import React from 'react';
import { Provider } from 'react-redux';
import Amplify from 'aws-amplify';
import { QueryClientProvider } from '@tanstack/react-query';

import { store } from './app/store';
import { GlobalStyles } from './GlobalStyles';
import { AppRouter } from './routes/Router';
import { AmplifyAuthChangeHandler } from './auth/AmplifyAuthChangeHandler';

import { AuthConditionalRender } from './auth/AuthConditionalRender';
import { ShowSiteLoading } from './SiteLoadingIndicator';
import {
   apiEnv,
   authStatuses,
   permissionsStatuses,
   userPoolEnv,
} from './util/constants';
import { LazyLoadSubscribe } from './LazyLoadSubscribe';
import { VisibleScreenDimentions } from './VisibleScreenDimentions';
import { PermissionsConditionalRender } from './permissions/PermissionsConditionalRender';
import { PermissionsErrorOverlay } from './permissions/PermissionsErrorOverlay';
import { queryClient } from './app/queryClient';

Amplify.configure({
   aws_project_region: 'us-west-2',
   aws_user_pools_id: userPoolEnv.pool,
   aws_user_pools_web_client_id: userPoolEnv.client,
   aws_cloud_logic_custom: [
      {
         name: 'app',
         endpoint: apiEnv.appEndpoint,
      },
   ],
});

const App = () => (
   <QueryClientProvider client={queryClient}>
      <Provider store={store}>
         <VisibleScreenDimentions />
         <GlobalStyles />
         <AmplifyAuthChangeHandler />
         <AppRouter />
         <LazyLoadSubscribe />
         <PermissionsConditionalRender
            allowedStatuses={[permissionsStatuses.failed]}
         >
            <PermissionsErrorOverlay />
         </PermissionsConditionalRender>
         <AuthConditionalRender allowedStatuses={[authStatuses.pending]}>
            <ShowSiteLoading />
         </AuthConditionalRender>
      </Provider>
   </QueryClientProvider>
);

// Needed for code splitting
// eslint-disable-next-line import/no-default-export
export default App;
